// Bug MEP — Univers Métier (WP-delegated) activity/atelier video player.
//
// The WP theme ships assets/js/activite-video.js as an IIFE, but our Rails
// delegation re-injects WP JS in <head> WITHOUT defer: it runs before the
// .nt-single__media thumbnail exists in the body (querySelector → null → no
// binding), and Turbo Drive doesn't re-run head scripts on navigation. So the
// overlay click never launched the lazy Bunny Stream iframe (broken on first
// load AND on the second video). We bind it Rails-side instead, on turbo:load
// (and initial load), so it works without touching/deploying the WP theme.
//
// The `data-video-bound` guard is the SAME the theme's own fix uses, so if both
// ever ship they never double-bind (first to run wins, the other skips).
import Tracking from './tracking';
import { universMetierPageProperties } from './univers_metier_tracking';

function launch(media) {
  if (media.classList.contains('is-playing')) return;

  const videoUrl = media.getAttribute('data-video-url');
  if (!videoUrl) return;

  const src = videoUrl + (videoUrl.indexOf('?') === -1 ? '?' : '&') + 'autoplay=true';
  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.loading = 'lazy';
  iframe.allow = 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;';
  iframe.allowFullscreen = true;
  iframe.title = "Vidéo de l'activité";

  // Remplace l'image + bouton play par l'iframe (mêmes effets que le thème WP).
  media.innerHTML = '';
  media.appendChild(iframe);
  media.classList.add('is-playing');
  media.removeAttribute('role');
  media.removeAttribute('tabindex');
  media.removeAttribute('aria-label');

  // GTM — KPI vues vidéos activités/ateliers (parité avec activite-video.js).
  if (window.NTGtm) {
    window.NTGtm.push('video_play', {
      content_id: media.getAttribute('data-content-id') || '',
      content_type: media.getAttribute('data-content-type') || '',
      content_title: media.getAttribute('data-content-title') || '',
      video_url: videoUrl,
    });
  }

  // TW-3220 — Amplitude (watch time stays on the Bunny side).
  Tracking.amplitudeTracking('video.univers-metier.started', {
    ...universMetierPageProperties(),
    'video-title': media.getAttribute('data-content-title') || '',
  });
}

function initActivityVideo() {
  const media = document.querySelector('.nt-single__media.has-video');
  if (!media || media.dataset.videoBound) return;
  if (!media.getAttribute('data-video-url')) return;

  media.dataset.videoBound = '1';
  media.addEventListener('click', () => launch(media));
  media.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      launch(media);
    }
  });
}

document.addEventListener('turbo:load', initActivityVideo);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initActivityVideo);
} else {
  initActivityVideo();
}

export { initActivityVideo };
